import * as isoRegions from 'iso-3166-2';
import { fromJS } from 'immutable';
import { toPairs, orderBy } from 'lodash';

export function getTranslatedRegionsForCountry(isoCountryCode, intl) {
  const countryRegions = isoRegions.country(isoCountryCode);

  if (countryRegions) {
    const regions = countryRegions.sub;

    return toPairs(regions).map(([regionCode, region]) => {
      const id = `regions.${isoCountryCode}.${regionCode}`;
      const translationExists = Boolean(intl.messages[id]);
      let { name } = region;

      if (translationExists) {
        name = intl.formatMessage({ id });
      }

      // Discard the country code prefix – "CA-QC" -> "QC"
      const code = regionCode.split('-')[1];

      return {
        code,
        name,
      };
    });
  }

  return [];
}

// Given a country code and a region code, determines if the region is in the
// given country. Region code should not include the country prefix i.e 'AB'
// not 'CA-AB'.
export function isRegionInCountry(isoCountryCode, regionCode) {
  const regions = isoRegions.country(isoCountryCode) || { sub: {} };

  return Boolean(regions.sub[`${isoCountryCode}-${regionCode}`]);
}

export function getDropdownFormattedRegionsListForCountry(isoCountryCode, intl) {
  let regions = getTranslatedRegionsForCountry(isoCountryCode, intl);

  // @ts-expect-error TS(2322): Type '{ id: string; value: string; renderedValue: ... Remove this comment to see the full error message
  regions = regions.map((region) => ({
    id: region.code,
    value: region.code,
    renderedValue: region.name,
  }));

  return fromJS(orderBy(regions, 'renderedValue'));
}

export function getTranslatedRegionsList(isoCountryCode, intl) {
  let regions = getTranslatedRegionsForCountry(isoCountryCode, intl);

  // @ts-expect-error TS(2322): Type '{ value: string; key: string; label: string;... Remove this comment to see the full error message
  regions = regions.map((region) => ({
    value: region.code,
    key: region.code,
    label: region.name,
  }));

  return orderBy(regions, 'label');
}
